enum Phase {
  NewDay = 1, Planning, Patrolling, Solving
}

export default Phase